// extracted by css-extract-rspack-plugin
export default {"CardLink":"rmA8G","CardText":"VdO9Z","TextLink":"z1piF"};